var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbdocdashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228.782,
    height: 42.982,
    viewBox: "0 0 228.782 42.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hbdocdashboard",
    transform: "translate(-1447.548 -2154.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(1407.87 2154.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Approve",
    d: "M78.243,0h9.735c7.425,0,12.474-4.686,12.474-11.55S95.4-23.1,87.978-23.1H78.243Zm3.3-2.871V-20.229H87.78c5.709,0,9.372,3.5,9.372,8.679S93.489-2.871,87.78-2.871Zm29.535-14.784a11.647,11.647,0,0,0-7.227,2.244l1.32,2.376a8.845,8.845,0,0,1,5.544-1.881c3.135,0,4.686,1.551,4.686,4.224v.627h-5.016c-5.214,0-7.029,2.31-7.029,5.115,0,3.036,2.508,5.148,6.468,5.148,2.739,0,4.686-.924,5.742-2.508V0h3V-10.56C118.569-15.345,115.863-17.655,111.078-17.655Zm-.726,15.411c-2.409,0-3.861-1.089-3.861-2.838,0-1.485.891-2.706,4.026-2.706H115.4v2.442a5.072,5.072,0,0,1-5.048,3.1ZM129.129.2c4.653,0,7.557-2.013,7.557-5.181,0-6.8-11.088-3.432-11.088-7.557,0-1.386,1.353-2.409,4.125-2.409a9.134,9.134,0,0,1,5.049,1.386l1.353-2.508a12.727,12.727,0,0,0-6.369-1.584c-4.488,0-7.293,2.112-7.293,5.247,0,6.963,11.055,3.564,11.055,7.491,0,1.485-1.221,2.376-4.158,2.376a11.239,11.239,0,0,1-6.138-1.815L121.9-1.848A12.623,12.623,0,0,0,129.129.2Zm20.526-17.853a7.584,7.584,0,0,0-6.171,2.64v-9.471h-3.168V0h3.168V-9.009c0-3.8,2.178-5.808,5.544-5.808,3,0,4.719,1.683,4.719,5.115V0h3.168V-10.065c0-5.148-3-7.59-7.26-7.59Zm22.077,0a7.442,7.442,0,0,0-6.1,2.8v-9.636h-3.168V0H165.5V-2.772A7.389,7.389,0,0,0,171.732.2a8.516,8.516,0,0,0,6.394-2.521,8.516,8.516,0,0,0,2.45-6.422,8.489,8.489,0,0,0-2.452-6.41,8.489,8.489,0,0,0-6.391-2.5Zm-.264,15.081c-3.333,0-5.874-2.442-5.874-6.171a5.756,5.756,0,0,1,1.585-4.363,5.756,5.756,0,0,1,4.289-1.775,5.764,5.764,0,0,1,4.308,1.765,5.764,5.764,0,0,1,1.6,4.373,5.791,5.791,0,0,1-1.6,4.384,5.791,5.791,0,0,1-4.311,1.785ZM192.126.2a8.7,8.7,0,0,0,6.485-2.5A8.7,8.7,0,0,0,201.2-8.745a8.676,8.676,0,0,0-2.594-6.434,8.676,8.676,0,0,0-6.481-2.476,8.705,8.705,0,0,0-9.108,8.91,8.729,8.729,0,0,0,2.61,6.453A8.729,8.729,0,0,0,192.126.2Zm0-2.772a5.791,5.791,0,0,1-4.312-1.785,5.791,5.791,0,0,1-1.6-4.386,5.764,5.764,0,0,1,1.6-4.373,5.764,5.764,0,0,1,4.308-1.765c3.366,0,5.874,2.409,5.874,6.138s-2.508,6.169-5.874,6.169Zm19.338-15.081a11.647,11.647,0,0,0-7.227,2.244l1.32,2.376a8.845,8.845,0,0,1,5.544-1.881c3.135,0,4.686,1.551,4.686,4.224v.627h-5.016c-5.214,0-7.029,2.31-7.029,5.115C203.742-1.914,206.25.2,210.21.2c2.739,0,4.686-.924,5.742-2.508V0h3V-10.56c0-4.785-2.7-7.1-7.488-7.1Zm-.726,15.411c-2.409,0-3.861-1.089-3.861-2.838,0-1.485.891-2.706,4.026-2.706h4.884v2.442a5.072,5.072,0,0,1-5.049,3.1Zm16.8-12.309V-17.49H224.5V0h3.168V-8.712c0-3.828,2.112-5.907,5.511-5.907a5.594,5.594,0,0,1,.726.033v-3.069c-3.07,0-5.248,1.055-6.37,3.1Zm23.1-9.933v9.636a7.442,7.442,0,0,0-6.1-2.805,8.489,8.489,0,0,0-6.391,2.5,8.489,8.489,0,0,0-2.453,6.409,8.516,8.516,0,0,0,2.449,6.421A8.516,8.516,0,0,0,244.53.2a7.389,7.389,0,0,0,6.237-2.97V0H253.8V-24.486Zm-5.844,21.91a5.791,5.791,0,0,1-4.312-1.785,5.791,5.791,0,0,1-1.6-4.386,5.764,5.764,0,0,1,1.6-4.373,5.764,5.764,0,0,1,4.308-1.765,5.756,5.756,0,0,1,4.289,1.775,5.756,5.756,0,0,1,1.585,4.363C250.668-5.016,248.127-2.574,244.794-2.574Z",
    transform: "translate(14.66 33)",
    fill: "#fff",
    opacity: 0.796
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logo-Dashboard",
    transform: "translate(1447.678 2153.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve",
    transform: "translate(-0.13 0.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    d: "M0,0H42.982V13.225a4.133,4.133,0,0,1-4.133,4.133H4.133A4.133,4.133,0,0,1,0,13.225Z",
    transform: "translate(0 25.624)",
    fill: "#064b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    d: "M0,0H42.982V21.491a4.133,4.133,0,0,1-4.133,4.133H4.133A4.133,4.133,0,0,1,0,21.491Z",
    transform: "translate(42.982 25.624) rotate(180)",
    fill: "#fbba00"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DB",
    transform: "translate(12 37.991)",
    fill: "#fff",
    stroke: "#feffff",
    strokeWidth: 0.6,
    fontSize: 13,
    fontFamily: "Young",
    letterSpacing: "0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DB")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_775",
    "data-name": "Groupe 775",
    transform: "translate(2.431 0.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1416",
    "data-name": "Trac\\xE9 1416",
    d: "M16,12.814H13.137a.355.355,0,0,0-.326.377V31.348a.355.355,0,0,0,.326.377H16a.355.355,0,0,0,.326-.377V13.191A.355.355,0,0,0,16,12.814Z",
    transform: "translate(-6.269 -6.132)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1417",
    "data-name": "Trac\\xE9 1417",
    d: "M10.4,12.581H7.537a.355.355,0,0,0-.326.377V31.115a.355.355,0,0,0,.326.377H10.4a.355.355,0,0,0,.326-.377V12.958a.355.355,0,0,0-.326-.377Z",
    transform: "translate(-7.21 -6.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1418",
    "data-name": "Trac\\xE9 1418",
    d: "M21.833,10.9H18.971a.355.355,0,0,0-.326.377V31.4a.355.355,0,0,0,.326.377h2.862a.355.355,0,0,0,.326-.377V11.278A.355.355,0,0,0,21.833,10.9Z",
    transform: "translate(-5.292 -6.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1419",
    "data-name": "Trac\\xE9 1419",
    d: "M27.663,9.263H24.8a.355.355,0,0,0-.326.377v22.3a.355.355,0,0,0,.326.377h2.864a.355.355,0,0,0,.326-.377V9.64A.355.355,0,0,0,27.663,9.263Z",
    transform: "translate(-4.313 -6.729)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1420",
    "data-name": "Trac\\xE9 1420",
    d: "M39.458,9.263H36.6a.355.355,0,0,0-.326.377v22.3a.355.355,0,0,0,.326.377h2.864a.355.355,0,0,0,.326-.377V9.64A.355.355,0,0,0,39.458,9.263Z",
    transform: "translate(-2.333 -6.729)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1421",
    "data-name": "Trac\\xE9 1421",
    d: "M33.493,7.1H30.631a.355.355,0,0,0-.326.377v24.56a.355.355,0,0,0,.326.377h2.862a.355.355,0,0,0,.326-.377V7.47a.355.355,0,0,0-.326-.377Z",
    transform: "translate(-3.334 -7.093)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbdocdashboard);
export default __webpack_public_path__ + "static/media/hbdocdashboard.8fcea50db513bc53b789529bfc4c641f.svg";
export { ForwardRef as ReactComponent };